"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AOS from "aos";
gsap.registerPlugin(ScrollTrigger);

// Bar de progression du site
document.addEventListener('scroll', function() {
  const windowHeight = window.innerHeight;
  const documentHeight = document.body.clientHeight;
  const scrollPosition = window.scrollY;

  const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;

  const progressBar = document.querySelector('.progress-container_bar');
  progressBar.style.width = scrollPercentage + '%';
});

/* Burger */
document.addEventListener('DOMContentLoaded', initNav);
function initNav() {
  const burger = document.querySelector('.main-nav_burger');
  const nav = document.querySelector('.main-nav');
  burger.addEventListener('click', () => {
    nav.classList.toggle('show');
    if (nav.classList.contains('show')) {
      document.documentElement.style.overflowY = 'hidden';
    } else {
      document.documentElement.style.overflowY = 'auto';
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const burgerMenu = document.querySelector(".main-nav");
  const menuLinks = document.querySelectorAll(".main-nav_links_el_link");

  menuLinks.forEach(link => {
    link.addEventListener("click", () => {
      burgerMenu.classList.remove("show");
      document.documentElement.style.overflowY = 'auto';
    });
  });
});

//Animation
AOS.init();

//Seulement index.html
if (window.location.href === "https://nicolascoopman.be/projets/tfaaout/" || window.location.href === "https://nicolascoopman.be/projets/tfaaout/#scroll" || window.location.href === "https://nicolascoopman.be/projets/tfaaout/index.html" || window.location.href === "https://nicolascoopman.be/projets/tfaaout/index.html#scroll" || window.location.href === "http://nicolascoopman.be/projets/tfaaout/" || window.location.href === "http://nicolascoopman.be/projets/tfaaout/index.html" ||window.location.href === "http://nicolascoopman.be/projets/tfaaout/#scroll " || window.location.href === "http://nicolascoopman.be/projets/tfaaout/index.html#scroll" || window.location.pathname === "/index.html") {

// Copyright
let year = new Date().getFullYear();
let date = document.querySelector("#date");
date.innerHTML = "©SpikeZ"+ String(year);
}
